import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SortOrder, UnitQuerySortColumn, type UnitsQueryModel } from 'api/hu'
import { RootState } from 'appHooks'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'

export const unitsListInitialFilters: UnitsQueryModel = {
  searchText: null,
  sortColumn: UnitQuerySortColumn.ShareOrSectionNumber,
  sortorder: SortOrder.Ascending,
  addressId: null,
  take: DEFAULT_PAGE_TAKE,
  skip: 0,
}

const unitsFiltersSlice = createSlice({
  name: 'unitsFilters',
  initialState: unitsListInitialFilters,
  reducers: {
    patchUnitsFilters: (
      state,
      action: PayloadAction<Partial<UnitsQueryModel>>
    ) => ({ ...state, ...action.payload }),
    resetUnitsFilters: () => unitsListInitialFilters,
  },
})

export const getUnitsFilters = (state: RootState) => state.unitsFilters

export const { patchUnitsFilters, resetUnitsFilters } =
  unitsFiltersSlice.actions

export default unitsFiltersSlice
